export const types = {
  EVENT: 'Event',
  PODCAST: 'Podcast',
  MAZE: 'Maze',
  COURSE: 'Course',
  SKILLJOURNEY: 'Skill Journey',
  LIVE: 'Live',
  CHANNEL: 'Channel'
}
